import React, { Component } from 'react';
import login from './../login.js';
class Logout extends Component {
	componentWillMount() {
		login.doLogout();
	}

	render() {
		return (
			<div id="logout" />
		);
	}
}

export default Logout;



// WEBPACK FOOTER //
// ./mobile-core/src/components/logout.js